export const CHARTER_SEAT_CLEAR_BLOCKED_MESSAGE =
  'To remove a seat assignment, cancel the seat add-on from the order (seat refund flow). You can assign a different seat here.';
